export default __webpack_public_path__ + "static/media/Astro_Libra_Black.4dc1024f.png";